'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectWithoutProperties = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _asyncToGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var CID = require('cids');

var Client = require('../../lib/core');

var Service = require('./service');

var toUrlSearchParams = require('../../lib/to-url-search-params');
/**
 * @typedef {import('../..').HttpOptions} HttpOptions
 * @typedef {import('../../lib/core').ClientOptions} ClientOptions
 * @typedef {import('ipfs-core-types/src/basic').AbortOptions} AbortOptions
 * @typedef {import('ipfs-core-types/src/pin/remote').API} API
 * @typedef {import('ipfs-core-types/src/pin/remote').Pin} Pin
 * @typedef {import('ipfs-core-types/src/pin/remote').AddOptions} AddOptions
 * @typedef {import('ipfs-core-types/src/pin/remote').Query} Query
 * @typedef {import('ipfs-core-types/src/pin/remote').Status} Status
 *
 * @implements {API}
 */


var Remote = /*#__PURE__*/function () {
  /**
   * @param {ClientOptions} options
   */
  function Remote(options) {
    _classCallCheck(this, Remote);

    /** @private */
    this.client = new Client(options);
    /** @readonly */

    this.service = new Service(options);
  }
  /**
   * Stores an IPFS object(s) from a given path to a remote pinning service.
   *
   * @param {CID} cid
   * @param {AddOptions & AbortOptions & HttpOptions} options
   * @returns {Promise<Pin>}
   */


  _createClass(Remote, [{
    key: "add",
    value: function add(cid, options) {
      return Remote.add(this.client, cid, options);
    }
    /**
     * @param {Client} client
     * @param {CID} cid
     * @param {AddOptions & AbortOptions & HttpOptions} options
     */

  }, {
    key: "ls",

    /**
     * Returns a list of matching pins on the remote pinning service.
     *
     * @param {Query & AbortOptions & HttpOptions} query
     */
    value: function ls(query) {
      return Remote.ls(this.client, query);
    }
    /**
     *
     * @param {Client} client
     * @param {Query & AbortOptions & HttpOptions} options
     * @returns {AsyncIterable<Pin>}
     */

  }, {
    key: "rm",

    /**
     * Removes a single pin object matching query allowing it to be garbage
     * collected (if needed). Will error if multiple pins mtach provided
     * query. To remove all matches use `rmAll` instead.
     *
     * @param {Query & AbortOptions & HttpOptions} query
     */
    value: function rm(query) {
      return Remote.rm(this.client, _objectSpread({}, query, {
        all: false
      }));
    }
    /**
     * Removes all pin object that match given query allowing them to be garbage
     * collected if needed.
     *
     * @param {Query & AbortOptions & HttpOptions} query
     */

  }, {
    key: "rmAll",
    value: function rmAll(query) {
      return Remote.rm(this.client, _objectSpread({}, query, {
        all: true
      }));
    }
    /**
     *
     * @param {Client} client
     * @param {{all: boolean} & Query & AbortOptions & HttpOptions} options
     */

  }], [{
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, cid, _ref) {
        var timeout, signal, headers, options, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                timeout = _ref.timeout, signal = _ref.signal, headers = _ref.headers, options = _objectWithoutProperties(_ref, ["timeout", "signal", "headers"]);
                _context.next = 3;
                return client.post('pin/remote/add', {
                  timeout: timeout,
                  signal: signal,
                  headers: headers,
                  searchParams: encodeAddParams(_objectSpread({
                    cid: cid
                  }, options))
                });

              case 3:
                response = _context.sent;
                _context.t0 = Remote;
                _context.next = 7;
                return response.json();

              case 7:
                _context.t1 = _context.sent;
                return _context.abrupt("return", _context.t0.decodePin.call(_context.t0, _context.t1));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function add(_x, _x2, _x3) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
    /**
     * @param {Object} json
     * @param {string} json.Name
     * @param {string} json.Cid
     * @param {Status} json.Status
     * @returns {Pin}
     */

  }, {
    key: "decodePin",
    value: function decodePin(_ref2) {
      var name = _ref2.Name,
          status = _ref2.Status,
          cid = _ref2.Cid;
      return {
        cid: new CID(cid),
        name: name,
        status: status
      };
    }
  }, {
    key: "ls",
    value: function ls(client, _ref3) {
      var timeout = _ref3.timeout,
          signal = _ref3.signal,
          headers = _ref3.headers,
          query = _objectWithoutProperties(_ref3, ["timeout", "signal", "headers"]);

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, pin;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _awaitAsyncGenerator(client.post('pin/remote/ls', {
                  signal: signal,
                  timeout: timeout,
                  headers: headers,
                  searchParams: encodeQuery(query)
                }));

              case 2:
                response = _context2.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 5;
                _iterator = _asyncIterator(response.ndjson());

              case 7:
                _context2.next = 9;
                return _awaitAsyncGenerator(_iterator.next());

              case 9:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 13;
                return _awaitAsyncGenerator(_step.value);

              case 13:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 21;
                  break;
                }

                pin = _value;
                _context2.next = 18;
                return Remote.decodePin(pin);

              case 18:
                _iteratorNormalCompletion = true;
                _context2.next = 7;
                break;

              case 21:
                _context2.next = 27;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 27:
                _context2.prev = 27;
                _context2.prev = 28;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 32;
                return _awaitAsyncGenerator(_iterator.return());

              case 32:
                _context2.prev = 32;

                if (!_didIteratorError) {
                  _context2.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context2.finish(32);

              case 36:
                return _context2.finish(27);

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 23, 27, 37], [28,, 32, 36]]);
      }))();
    }
  }, {
    key: "rm",
    value: function () {
      var _rm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client, _ref4) {
        var timeout, signal, headers, query;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                timeout = _ref4.timeout, signal = _ref4.signal, headers = _ref4.headers, query = _objectWithoutProperties(_ref4, ["timeout", "signal", "headers"]);
                _context3.next = 3;
                return client.post('pin/remote/rm', {
                  timeout: timeout,
                  signal: signal,
                  headers: headers,
                  searchParams: encodeQuery(query)
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function rm(_x4, _x5) {
        return _rm.apply(this, arguments);
      }

      return rm;
    }()
  }]);

  return Remote;
}();
/**
 * @param {any} service
 * @returns {string}
 */


var encodeService = function encodeService(service) {
  if (typeof service === 'string' && service !== '') {
    return service;
  } else {
    throw new TypeError('service name must be passed');
  }
};
/**
 * @param {any} cid
 * @returns {string}
 */


var encodeCID = function encodeCID(cid) {
  if (CID.isCID(cid)) {
    return cid.toString();
  } else {
    throw new TypeError("CID instance expected instead of ".concat(cid));
  }
};
/**
 * @param {Query & { all?: boolean }} query
 * @returns {URLSearchParams}
 */


var encodeQuery = function encodeQuery(_ref5) {
  var service = _ref5.service,
      cid = _ref5.cid,
      name = _ref5.name,
      status = _ref5.status,
      all = _ref5.all;
  var query = toUrlSearchParams({
    service: encodeService(service),
    name: name,
    force: all ? true : undefined
  });

  if (cid) {
    var _iterator2 = _createForOfIteratorHelper(cid),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        query.append('cid', encodeCID(value));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  if (status) {
    var _iterator3 = _createForOfIteratorHelper(status),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _value2 = _step3.value;
        query.append('status', _value2);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return query;
};
/**
 * @param {AddOptions & {cid:CID}} options
 * @returns {URLSearchParams}
 */


var encodeAddParams = function encodeAddParams(_ref6) {
  var cid = _ref6.cid,
      service = _ref6.service,
      background = _ref6.background,
      name = _ref6.name,
      origins = _ref6.origins;
  var params = toUrlSearchParams({
    arg: encodeCID(cid),
    service: encodeService(service),
    name: name,
    background: background ? true : undefined
  });

  if (origins) {
    var _iterator4 = _createForOfIteratorHelper(origins),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var origin = _step4.value;
        params.append('origin', origin.toString());
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return params;
};

module.exports = Remote;